<script setup lang="ts">
import { computed, ref } from 'vue';
import { usePermissions } from '@/composables/usePermissions';
import ResponsiveTabs from '@/components/responsive-tabs.vue';
import InventoryAlertsList from './inventory-alerts-list.vue';
import InventoryCatalog from './inventory-catalog.vue';
import InventoryLocationsList from './inventory-locations-list.vue';
import InventoryWarehouseStock from './inventory-warehouse-stock.vue';

const { hasPermission } = usePermissions();

const tabs = [
  { value: 'alerts', title: 'Alertas', icon: 'mdi-bell-alert' },
  { value: 'catalog', title: 'Catálogo', icon: 'mdi-package-variant' },
  { value: 'warehouses', title: 'Stock en bodegas', icon: 'mdi-warehouse' },
  { value: 'locations', title: 'Configuración', icon: 'mdi-cog' },
];

// Deep-linkable (?tab=catalog) without a client router.
function initialTab(): string {
  const requested = new URLSearchParams(window.location.search).get('tab');

  return tabs.some((tab) => tab.value === requested) ? requested as string : 'alerts';
}

const activeTab = ref(initialTab());
const canIndex = computed(() => hasPermission.value('inventory', 'index'));
</script>
<template>
  <v-container v-if="canIndex">
    <h1 class="mb-4 text-h4">
      Inventario
    </h1>
    <v-card>
      <responsive-tabs
        v-model="activeTab"
        :items="tabs"
      />
      <v-window v-model="activeTab">
        <v-window-item value="alerts">
          <inventory-alerts-list />
        </v-window-item>
        <v-window-item value="catalog">
          <inventory-catalog />
        </v-window-item>
        <v-window-item value="warehouses">
          <inventory-warehouse-stock />
        </v-window-item>
        <v-window-item value="locations">
          <inventory-locations-list />
        </v-window-item>
      </v-window>
    </v-card>
  </v-container>
</template>
